import React from 'react'
import Empty from '../../../images/empty.svg'

const EmptyCardImage = () => (
	<img src={Empty} alt="" />
)

export default EmptyCardImage
